import { Component, Prop, h } from '@stencil/core';

import { actions as bannerAction } from '../../../actions/actions.interactive-banner';
import { textResetSizeType } from '../../../utils/utils.interactive-banner';

export type TexResetSize = 'xs' | 'sm';
@Component({
  tag: 'banner-reset',
  styleUrl: './banner-reset.css',
})
export class BannerReset {
  @Prop() textLink: string;
  @Prop() showDesktop: boolean = false;
  @Prop() textResetSize: textResetSizeType = 'xs';

  onClick() {
    bannerAction.onTrackBannerReset(this.textLink);
    bannerAction.resetBannerState();
    bannerAction.resetSessionStorageSteps();
  }

  render() {
    const resetClass = {
      'text-right leading-6 p-[1.6px] cursor-pointer flex place-items-end': true,
      'justify-end': this.showDesktop,
      'text-xs': this.textResetSize === 'xs',
      'text-sm': this.textResetSize === 'sm',
    };
    return (
      <ico-hyperlink class={resetClass} content="primary" onClick={() => this.onClick()}>
        {this.textLink}
      </ico-hyperlink>
    );
  }
}
